const FANXO_VISITOR_ID_KEY = "fanxo_visitor_id";

const createVisitorId = () => {
  const cryptoApi = window.crypto || (window as any).msCrypto;
  const uuid =
    typeof cryptoApi?.randomUUID === "function"
      ? cryptoApi.randomUUID()
      : `${Date.now()}_${Math.random().toString(36).slice(2)}_${Math.random()
          .toString(36)
          .slice(2)}`;

  return `fanxo_anon_${uuid.replace(/[^A-Za-z0-9_-]/g, "")}`;
};

export const getOrCreateFanxoVisitorId = () => {
  if (typeof window === "undefined") return "";

  const fromUrl = new URLSearchParams(window.location.search).get("visitorId");
  const existing = fromUrl || localStorage.getItem(FANXO_VISITOR_ID_KEY);
  if (existing) {
    localStorage.setItem(FANXO_VISITOR_ID_KEY, existing);
    return existing;
  }

  const visitorId = createVisitorId();
  localStorage.setItem(FANXO_VISITOR_ID_KEY, visitorId);
  return visitorId;
};

export const appendVisitorIdToUrl = (rawUrl: string) => {
  const visitorId = getOrCreateFanxoVisitorId();
  const url = new URL(rawUrl);
  url.searchParams.set("visitorId", visitorId);
  return url.toString();
};
